import { createContext } from 'react'
import type { components } from '@/api/types'

/**
 * Admin auth-user shape (a backend `AdminAuthUserResource`-jával egyezik,
 * a codegen-elt openapi types `AdminAuthUser` schema-ja).
 */
export type AdminAuthUser = NonNullable<components['schemas']['AdminAuthUser']>

export interface AuthContextValue {
  authUser: AdminAuthUser | null
  token: string | null
  /** Token van localStorage-ben, de a `/admin/auth/me` hidratálás még folyamatban van. */
  isInitializing: boolean
  setSession: (params: { token: string; authUser: AdminAuthUser }) => void
  clearSession: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)
